import React, { useState, useEffect, useContext } from 'react';

import './navigation.css';
import { Link } from 'react-router-dom';
import { LinkManager, prepareRequest } from '../../utils';
import PropTypes from 'prop-types';
import { useErrorHandler } from 'react-error-boundary';
import Flyout from '../../utils/flyout';
import { AppContext } from '../../utils/context';
import Image from '../image/image';

export const NavigationGQL = `query ScreenList($locale: String!) {
  screenList(
    filter: {positionInNavigation: {_expressions: [{value: "dni", _operator: CONTAINS_NOT}]}}
    _locale: $locale
  ) {
    items {
      _metadata {
        stringMetadata {
          name
          value
        }
      }
      _path
      positionInNavigation
    }
  }
}`;

const Navigation = ({ className, config, screen }) => {
  const context = useContext(AppContext);
  const [nav, setNav] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [logo, setLogo] = useState({});
  const handleError = useErrorHandler();

  let obj = {
    pos1: { name: '', path: '#' },
    pos2: { name: '', path: '#' },
    pos3: { name: '', path: '#' },
    pos4: { name: '', path: '#' },
    pos5: { name: 'Settings', path: '/settings' },
  };

  useEffect(() => {
    const sdk = prepareRequest(context);
    setLogo(config.configurationByPath.item.siteLogo);

    sdk.runPersistedQuery('aem-demo-assets/gql-demo-navigation', { locale: 'en' })
      .then((data) => {
        if (data) {
          setNav(data);
          context.navigationResponse = data;
        }
      })
      .catch((error) => {
        handleError(error);
      });
  }, [handleError, config, context]);

  nav && nav.data.screenList.items.forEach((item) => {
    if (item._path.includes(context.project)) {
      let name = '';
      item._metadata.stringMetadata.forEach(meta => {
        meta.name === 'title' && (name = meta.value);
      });
      obj[item.positionInNavigation] = { name: name, path: LinkManager(item._path, config, context) };
    }
  });

  function viewGQL() {
    document.querySelector('#flyout') && document.querySelector('#flyout').setAttribute('aria-expanded', true);
    return false;
  }

  let prevScrollPos = window.pageYOffset;
  window.onscroll = function () {
    let currentScrollPos = window.pageYOffset;
    if (prevScrollPos > currentScrollPos) {
      if (document.getElementById('navbar'))
        document.getElementById('navbar').style.top = '0';
    } else {
      if (document.getElementById('navbar'))
        document.getElementById('navbar').style.top = '-80px';
    }
    prevScrollPos = currentScrollPos;
  };

  return (
    <React.Fragment>
      <nav id="navbar" aria-expanded={expanded}>
        <div className='nav-hamburger' onClick={() => {
          if (expanded) setExpanded(false);
          else setExpanded(true);
          document.body.style.overflowY = expanded ? '' : 'hidden';
        }}>
          <div className='nav-hamburger-icon'></div>
        </div>
        <div className='nav-brand'>
          <Link to={'/'}><Image alt='logo' asset={logo} width={108} height={56} /></Link>
        </div>
        <div className='nav-sections'>
          {nav && (
            <ul>
              <li><Link to={obj.pos1.path} className={`navItem ${className}`} name={obj.pos1.name}>{obj.pos1.name}</Link></li>
              <li><Link to={obj.pos2.path} className={`navItem ${className}`} name={obj.pos2.name}>{obj.pos2.name}</Link></li>
              <li><Link to={obj.pos3.path} className={`navItem ${className}`} name={obj.pos3.name}>{obj.pos3.name}</Link></li>
              <li><Link to={obj.pos4.path} className={`navItem ${className}`} name={obj.pos4.name}>{obj.pos4.name}</Link></li>
              <li><Link to={obj.pos5.path} className={`navItem ${className}`} name={obj.pos5.name}>{obj.pos5.name}</Link></li>
            </ul>
          )}
        </div>
        <div className='nav-tools'>
          <button href='#' className='button view-gql' aria-expanded='false' aria-controls='flyout' onClick={viewGQL}>View GraphQL</button>
        </div>
      </nav >
      <Flyout show={false} config={config} screen={screen} />
    </React.Fragment>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  config: PropTypes.object,
  screen: PropTypes.object,
  context: PropTypes.object
};

export default Navigation;